export default {
  title: '用户协议',
  docTitle: 'BetCorgi 用户协议',
  docSubtitle: '使用服务前，请认真阅读以下内容',
  intro: '请在注册、登录及使用平台服务前仔细阅读。点击同意或继续使用，即表示您理解并接受本协议。',
  s1Title: '协议范围',
  s1Body:
    '本协议适用于账号注册、登录、充值、提现、游戏、奖励、代理及平台提供的其他相关功能。具体活动规则、页面提示和风险说明均属于本协议的组成部分。',
  s2Title: '注册与账号安全',
  s2Body:
    '您应提供真实、准确且有效的信息，并妥善保管账号、登录密码、验证码及资金密码。通过您账号完成的操作，原则上视为本人操作；发现异常时应立即修改密码并联系平台。',
  s3Title: '用户资格',
  s3Body:
    '您确认已满 18 周岁，具备完全民事行为能力，并应自行确认所在地法律允许使用相关服务。平台有权基于合规、风控或地区限制暂停部分功能。',
  s4Title: '资金与交易',
  s4Body:
    '充值、提现及币种兑换以提交时页面显示的金额、手续费、汇率、限额和到账说明为准。请仅使用本人合法持有的支付或收款账户，并仔细核对收款信息、链类型及钱包地址。',
  s5Title: '奖励与活动',
  s5Body:
    '任务、返水、俸禄、红包和其他优惠可能设置参与条件、有效期、流水要求及领取限制。异常套利、批量账号或违反活动规则的行为，平台可取消资格并追回不当奖励。',
  s6Title: '禁止行为',
  s6Body:
    '不得冒用他人身份、盗用支付工具、干扰系统、利用漏洞、洗钱、欺诈、非法转售账号或实施其他违法违规行为。平台可视风险采取验证、限制交易、冻结或终止服务等措施。',
  s7Title: '服务变更与责任',
  s7Body:
    '因维护、网络、第三方服务或不可抗力可能造成延迟或暂时中断。平台将尽力保障服务稳定，并在法律允许的范围内按照实际情况处理。',
  s8Title: '协议更新与联系',
  s8Body:
    '协议更新后将通过页面提示、站内消息等方式告知。若您不同意更新内容，应停止使用相关服务；如有疑问，可通过在线客服联系我们。',
  done: '我已阅读',
}
